import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const netscalerAdc = defineConnector({
  identifier: "netscalerAdc",
  name: "NetScaler ADC",
  tagLine: "Application delivery controller",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) => domainToRegex(url),
  auth: (app) =>
    headerAuth([
      { name: "X-NITRO-USER", value: app.secret.username },
      { name: "X-NITRO-PASS", value: app.secret.password },
    ]),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need your NetScaler ADC instance URL and credentials with API access.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          target: { kind: "configuration", field: "url" },
          placeholder: "https://netscaler.example.com",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ url }) => `${url}/nitro/v1/config/nspartition?view=summary`,
  },
});
